import {
  TechnicalError,
  WifiInformationModel,
} from '@dch/products-business-logic';
import * as WifiInformationActions from '../actions/wifi-information.actions';

export interface WifiInformationState {
  wifiInformation: WifiInformationModel;
  isPending: boolean;
  error: TechnicalError;
}

export const initialState: WifiInformationState = {
  wifiInformation: null,
  isPending: false,
  error: null,
};

export function reducer(
  state: WifiInformationState = initialState,
  action: WifiInformationActions.Actions,
): WifiInformationState {
  switch (action.type) {
    case WifiInformationActions.GET_WIFI_INFORMATION:
      return {
        ...state,
        isPending: true,
        error: null,
      };
    case WifiInformationActions.GET_WIFI_INFORMATION_SUCCESS:
      return {
        ...state,
        wifiInformation: action.payload,
        isPending: false,
        error: null,
      };
    case WifiInformationActions.GET_WIFI_INFORMATION_FAILED:
      return {
        ...state,
        wifiInformation: null,
        error: action.payload,
        isPending: false,
      };
    default:
      return state;
  }
}

export const getWifiPrivateAccess24Ghz = (state: WifiInformationState) =>
  state.wifiInformation?.privateAccess24Ghz;
export const getTechnicalError = (state: WifiInformationState) => state.error;
export const getPending = (state: WifiInformationState) => state.isPending;
